import { removeHtmlTags } from '@portal-internet/core';
import clsx from 'clsx';
import Enllac from 'components/3cat/Enllac';
import Imatge from 'components/3cat/Imatge';
import { useEffect, useState } from 'react';
import styles from './noticia.module.scss';

export default function Noticia(props) {
    const { data, estil, routeType } = props;
    const { id, titol, imatges, permatitle, priority, tipologia } = data;
    const entradeta = removeHtmlTags(data.entradeta);

    const [isHover, setIsHover] = useState(true);
    const [divHover, setDivHover] = useState(true);

    const route = {
        type: routeType,
        id: id,
        slug: permatitle || titol,
        tipologia: tipologia
    };

    const stylesItemMosaic = clsx({
        [styles.itemMosaic]: true,
        [styles[estil]]: true,
        ['focusable']: true
    });

    useEffect(() => {
        setDivHover('');
        if (isHover) {
            setTimeout(() => {
                if (isHover) setDivHover(clsx({ [styles.noticiaHover]: true }));
            }, 200);
        }
    }, [isHover]);

    const hoverHandler = (e) => {
        setIsHover(true);
    };
    const outHandler = () => {
        setIsHover(false);
    };

    return (
        <div className={`${stylesItemMosaic} ${divHover}`} onMouseEnter={hoverHandler} onMouseLeave={outHandler}>
            <div className={styles.wrapperItemMosaic}>
                <Enllac route={route}>
                    <div className={styles.imatge}>
                        <Imatge
                            imatges={imatges}
                            tipus='web_mosaic'
                            alt={titol}
                            aria-hidden='true'
                            layout='fill'
                            objectFit='cover'
                            loading='lazy'
                            crop='555x312'
                            priority={priority}
                        />
                    </div>
                </Enllac>

                <Enllac route={route} className={styles.info}>
                    <div className={styles.descripcio}>
                        <h2 className={styles.titol}>{titol}</h2>
                    </div>
                    <p className={styles.entradeta}>{entradeta}</p>
                </Enllac>
            </div>
        </div>
    );
}
